import React from 'react';
import ProductPricing from '../ProductPricing';
import ConsultProductPricing from '../ConsultProductPricing';

type DynamicProductPricingProps = {
  id?: string;
  hasConsulted?: boolean;
  boxProductId?: string;
  companyEmail?: string;
  companyWebsite?: string;
  contactPhone?: string;
  customerServiceWechatUrl?: string;
  priceContent?: string;
  boxProduct: { productName: string; boxProductId: string };
  onConsultSuccess?: () => void;
};
const DynamicProductPricing: React.FC<DynamicProductPricingProps> = ({
  id,
  hasConsulted,
  companyEmail,
  companyWebsite,
  contactPhone,
  customerServiceWechatUrl,
  priceContent,
  boxProduct,
  onConsultSuccess,
}) => {
  return hasConsulted ? (
    <ProductPricing
      id={id}
      companyEmail={companyEmail}
      companyWebsite={companyWebsite}
      contactPhone={contactPhone}
      customerServiceWechatUrl={customerServiceWechatUrl}
      priceContent={priceContent}
    />
  ) : (
    <ConsultProductPricing id={id} boxProduct={boxProduct} onConsultSuccess={onConsultSuccess} />
  );
};

export default DynamicProductPricing;
